// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function transaction_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "date"), null));
    if (date.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var is_reverted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_reverted"), null));
        if (is_reverted.TAG === /* Ok */0) {
          var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
          if (amount.TAG === /* Ok */0) {
            var wallet_balance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wallet_balance"), null));
            if (wallet_balance.TAG === /* Ok */0) {
              var payment_mode = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "payment_mode"), null));
              if (payment_mode.TAG === /* Ok */0) {
                var instamojo_payment_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "instamojo_payment_id"), null));
                if (instamojo_payment_id.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            order_id: order_id._0,
                            date: date._0,
                            description: description._0,
                            is_reverted: is_reverted._0,
                            amount: amount._0,
                            wallet_balance: wallet_balance._0,
                            payment_mode: payment_mode._0,
                            instamojo_payment_id: instamojo_payment_id._0
                          }
                        };
                }
                var e = instamojo_payment_id._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".instamojo_payment_id" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = payment_mode._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".payment_mode" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = wallet_balance._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".wallet_balance" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = amount._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".amount" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = is_reverted._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_reverted" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = date._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".date" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function result_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var wallet_balance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wallet_balance"), null));
  if (wallet_balance.TAG === /* Ok */0) {
    var last_date_timestamp = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_date_timestamp"), null));
    if (last_date_timestamp.TAG === /* Ok */0) {
      var transactions = Decco.listFromJson(transaction_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transactions"), null));
      if (transactions.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  wallet_balance: wallet_balance._0,
                  last_date_timestamp: last_date_timestamp._0,
                  transactions: transactions._0
                }
              };
      }
      var e = transactions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".transactions" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = last_date_timestamp._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_date_timestamp" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = wallet_balance._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".wallet_balance" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var result = result_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "result"), null));
  if (result.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              result: result._0
            }
          };
  }
  var e = result._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".result" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  transaction_decode ,
  result_decode ,
  t_decode ,
  
}
/* No side effect */
